import { useTranslation } from 'react-i18next';
import { motion } from 'framer-motion';
import { cn } from '@/lib/utils';
import { I18nNamespace } from '@/lib/i18n-namespaces';

interface ThresholdDividerProps {
    threshold: number;
    isPreviewing?: boolean;
}

export function ThresholdDivider({
    threshold,
    isPreviewing,
}: ThresholdDividerProps) {
    const { t } = useTranslation(I18nNamespace.EVENTS);
    return (
        <motion.div
            className="flex items-center gap-2 py-1.5"
            layout
            initial={{ opacity: 0 }}
            animate={{
                opacity: isPreviewing ? [0.5, 1, 0.5] : 1,
            }}
            exit={{ opacity: 0 }}
            transition={
                isPreviewing
                    ? {
                          opacity: {
                              duration: 1.5,
                              repeat: Infinity,
                              ease: 'easeInOut',
                          },
                      }
                    : { duration: 0.2 }
            }
        >
            <div
                className={cn(
                    'flex-1 border-t-2',
                    'border-solid border-grey-300',
                )}
            />
            <span
                className={cn(
                    'text-xs font-medium whitespace-nowrap',
                    isPreviewing ? 'text-grey-100' : 'text-grey-200',
                )}
            >
                {t('sidebar.confidenceThreshold', {
                    threshold: Math.round(threshold),
                })}
            </span>
            <div
                className={cn(
                    'flex-1 border-t-2',
                    'border-solid border-grey-300',
                )}
            />
        </motion.div>
    );
}
